import { create } from "zustand";
import { persist } from "zustand/middleware";

import { clearTokens, saveTokens } from "@/lib/api-client";
import type { AuthTokens, User } from "@/types/auth";

interface AuthState {
  user: User | null;
  tokens: AuthTokens | null;
  isAuthenticated: boolean;
  isBootstrapping: boolean;
  setSession: (u: User, t: AuthTokens) => void;
  setUser: (u: User) => void;
  logout: () => void;
  setBootstrapping: (v: boolean) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      tokens: null,
      isAuthenticated: false,
      isBootstrapping: true,
      setSession: (user, tokens) => {
        saveTokens(tokens);
        set({ user, tokens, isAuthenticated: true, isBootstrapping: false });
      },
      setUser: (user) => set({ user }),
      logout: () => {
        clearTokens();
        set({ user: null, tokens: null, isAuthenticated: false });
      },
      setBootstrapping: (v) => set({ isBootstrapping: v }),
    }),
    {
      name: "autoclub.auth",
      partialize: (s) => ({ user: s.user, tokens: s.tokens,
                              isAuthenticated: s.isAuthenticated }),
    },
  ),
);
